import { render, staticRenderFns } from "./pcFooter.vue?vue&type=template&id=63b3ad07&scoped=true"
import script from "./pcFooter.vue?vue&type=script&lang=js"
export * from "./pcFooter.vue?vue&type=script&lang=js"
import style0 from "./pcFooter.vue?vue&type=style&index=0&id=63b3ad07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b3ad07",
  null
  
)

export default component.exports